import { render } from "./FormFileItem.vue?vue&type=template&id=1de9ce2c"
import script from "./FormFileItem.vue?vue&type=script&lang=js"
export * from "./FormFileItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__